import React, { PropsWithChildren, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCookie } from '../../../utils/helper/helper';
import { handleAPI } from 'utils/api/api';
import { closeActionModal } from 'redux/slices/confirmationModalSlice';
import { Logout } from 'redux/slices/authSlice';
import { hasAccess } from 'utils/helper/access';

export interface PrivilegeProps extends PropsWithChildren {
  Key: string | string[];
  role?: string | string[];
  skipCheck?: boolean;
}

const Privilege = ({ Key, role, children, skipCheck }: PrivilegeProps) => {
  const dispatch = useDispatch();
  const { abilities, role: userRole } = useSelector((state: any) => state.auth);

  const logoutCallback = useCallback(async () => {
    const data = {
      user: {
        token: getCookie('token') ?? '',
      },
    };
    await handleAPI('platform/auth/logout', 'post', '', data);
    dispatch(closeActionModal() as any);
    dispatch(Logout());
    window.location.href = '/login';
  }, [dispatch]);

  const hasPrivilege = useMemo(() => {
    if (skipCheck) {
      return true;
    }
    if (!abilities) {
      logoutCallback();
      return false;
    }

    return hasAccess({ checkname: Key, role }, abilities, userRole);
  }, [abilities, Key, skipCheck, logoutCallback, role, userRole]);

  return <span>{hasPrivilege && children}</span>;
};

export default Privilege;
